import moment from "moment";
import { GET_BILLING_SERVICES_BY_PERIOD } from "../managements/MonthlyClosingDetail/queries";
import { openNcfPrincipalReport } from "./ncfPrincipalReport";
import { tryOpenReport } from "./openReport";

export const getLogoDataUrl = () => sessionStorage.getItem("imageLogo") || undefined;

// El API envia el rango del periodo; sin rango se usa el mes calendario.
export const getMonthlyClosingPeriod = (monthlyClosing) => {
  const month = Number(monthlyClosing?.month || 1);
  const year = Number(monthlyClosing?.year || moment().year());
  const monthStart = moment({ year, month: month - 1, day: 1 });
  const startDate = monthlyClosing?.periodStartDate
    ? moment(monthlyClosing.periodStartDate)
    : monthStart.clone();
  const endDate = monthlyClosing?.periodEndDate
    ? moment(monthlyClosing.periodEndDate)
    : monthStart.clone().endOf("month");

  return {
    startDate: startDate.format("YYYY-MM-DD"),
    endDate: endDate.format("YYYY-MM-DD"),
    dateLabel: endDate.format("DD/MM/YYYY"),
    periodLabel: `${String(month).padStart(2, "0")}/${year}`,
    rangeLabel: `${startDate.format("DD/MM/YYYY")} - ${endDate.format("DD/MM/YYYY")}`,
  };
};

export const getConsultoryReportData = (monthlyClosing) => ({
  consultoryName: monthlyClosing?.pharmacyProvider?.name,
  consultoryAddress: monthlyClosing?.pharmacyProvider?.address,
  consultoryRnc: monthlyClosing?.pharmacyProvider?.nif,
});

export const getBillingReportData = (billing) => ({
  voucherName: billing?.voucherName,
  voucherDueDate: billing?.voucherDueDate,
  insurerName: billing?.insurerName,
  insurerRnc: billing?.insurerRnc,
  ncf: billing?.ncf,
});

export const getBillingReportWhere = ({ monthlyClosingId, dataDoctor, billing }) => ({
  monthlyClosingId,
  medicalStaffId: dataDoctor?.medicalStaffId,
  branchOfficeId: dataDoctor?.branchOfficeId,
  arsId: billing?.arsId || null,
  ncf: billing?.ncf || "",
  saleIds: billing?.saleIds || [],
});

// Devuelve false cuando el navegador bloquea la ventana del PDF.
export const printNcfPrincipalReport = async (
  client,
  { monthlyClosing, billing, where, logoDataUrl = getLogoDataUrl() },
) => {
  const servicesResult = await client.query({
    query: GET_BILLING_SERVICES_BY_PERIOD,
    fetchPolicy: "network-only",
    variables: { where },
  });

  const details =
    servicesResult?.data?.getConsultoryMonthlyClosedServiceDetail || [];
  const valueFromDetails = details.reduce(
    (acc, item) => acc + Number(item?.value || 0),
    0,
  );
  const value =
    valueFromDetails > 0 ? valueFromDetails : Number(billing?.coverageValue || 0);

  return tryOpenReport(openNcfPrincipalReport, {
    logoDataUrl,
    ...getConsultoryReportData(monthlyClosing),
    ...getBillingReportData(billing),
    dateLabel: getMonthlyClosingPeriod(monthlyClosing).dateLabel,
    details,
    concept: "Servicios de Salud",
    value,
    total: value,
  });
};
